import React from "react";
import { useState, useEffect } from "react";
import {Link } from "react-router-dom"
//import { Navbar } from ".";

export default function Navbar({ token, setToken, setIsLoggedIn, isLoggedIn}) {
    
    const [cart, setCart] = useState([]);

    
    useEffect(() => {
      if (!token) return;
      setIsLoggedIn(true);
    }, [token]);

    useEffect(() => {
      // if (!token) return;
      // fetch("http://localhost:3000/cart", {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`,
      //   },
      // })
      //   .then((r) => r.json())
      //   .then((cart) => {
      //     setCart(cart);
      //   });
    }, [token]);
  
    function logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      setIsLoggedIn(false);
      setToken(null);
    }
  
    return (
      <nav className="navMenu">
        <div className="navTitle">
          <span>PenXV</span>
        </div>
        <div className="dot"></div>
        <div className="">
        <Link to="">Home</Link>
          <Link to="About_Us">About Us</Link>
          <Link to="Products">Products</Link>
          {!isLoggedIn && <Link to="Login">Login</Link>}
          {isLoggedIn && (
            <>
              <Link to="Cart">Cart</Link>
              <Link to="/Profile">My Profile</Link>
            </>
          )}
        </div>
      </nav>
    );
  }